import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataSavedEvent, ImageType, NewsData } from '../../news.model';
import { NewsService } from '../../news.service';
import { NotificationService } from '../../../shared/service/notification.service';

@Component({
  selector: 'app-item-images',
  templateUrl: './item-images.component.html',
  styleUrls: ['./item-images.component.scss'],
})
export class ItemImagesComponent implements OnInit {

  public fileAttrHeader = 'Select file';
  public fileAttrSummary = 'Select file';
  public showDeleteIconHeaderImage = false;
  public showDeleteIconSummaryImage = false;
  public headerImage: {
    imageAlt: string | null;
    href: string;
    id: string;
  } | undefined;
  public summaryImage: {
    imageAlt: string | null;
    href: string;
    id: string;
  } | undefined;

  @Input() itemData!: NewsData;
  @Output() dataSaved: EventEmitter<DataSavedEvent> = new EventEmitter();

  constructor(
    private newsService: NewsService,
    private notificationService: NotificationService,
  ) {
  }

  ngOnInit(): void {
    this.updateImagesSourceUrl();
  }

  private updateImagesSourceUrl(): void {
    this.headerImage = this.itemData._links?.headerImg;
    this.summaryImage = this.itemData._links?.summaryImg;
  }

  onSelect(event: Event, type: string): void {
    const files = (event.target as HTMLInputElement).files;

    if (!files) {
      return;
    }

    if (type === ImageType.HEADER) {
      this.fileAttrHeader = files[0].name;
    } else {
      this.fileAttrSummary = files[0].name;
    }

    this.newsService
      .uploadImage(this.itemData.id, files[0], type)
      .subscribe((next) => {
        this.dataSaved.emit({ itemId: this.itemData.id });
        this.notificationService.success_ts('news_item.image.uploaded');
      })
  }

  onRemove(type: string): void {
    this.newsService
      .uploadImage(this.itemData.id, null, type)
      .subscribe((next) => {
        this.dataSaved.emit({ itemId: this.itemData.id });
        this.notificationService.success_ts('news_item.image.removed');
      })
  }
}
